// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AyomD{cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/components/common/playIcon/PlayIcon.module.scss"],"names":[],"mappings":"AAAA,OACE,cAAA","sourcesContent":[".showCursor {\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"showCursor": `AyomD`
};
export default ___CSS_LOADER_EXPORT___;
